<template>
  <v-container fluid fill-width grid-list-sm class="remove-top-padding">
    <v-layout wrap>
      <v-flex xs5>
        <v-card>
          <v-card-text>
            <div>Filter:</div>

            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  :items="$store.state.vendors"
                  label="Vendor(s)"
                  v-model="selectedVendors"
                  item-text="vendorName"
                  item-value="_id"
                  chips
                  attach
                  multiple
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="$store.state.RequestStatus"
                  label="Request Status"
                  v-model="requestStatus"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Request ID" v-model="requestId"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Item ID" v-model="itemId"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select :items="$store.state.ECOStatus" label="ECO Status" v-model="ecoStatus"></v-select>
                <!-- @change="ecoStatusChanged()" -->
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="$store.state.TestingStatus"
                  label="Testing Status"
                  v-model="testingStatus"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="search" :disabled="isSearchable">Search</v-btn>
            <v-btn @click="clearSearchFilter">Clear Filter</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs2>
        <v-spacer></v-spacer>
      </v-flex>
      <v-flex xs5>
        <v-card>
          <v-card-text>
            <div>Update Values:</div>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  :items="$store.state.ECOStatus"
                  label="ECO Status"
                  v-model="updateEcoStatus"
                ></v-select>
                <!-- @change="ecoStatusChanged()" -->
              </v-flex>
              <!--<v-flex xs12>
                <v-select
                  :items="$store.state.FulfillmentStatus"
                  label="Fulfillment Status"
                  v-model="updateFulfillmentStatus"
                ></v-select>
              </v-flex> -->
              <v-flex xs12>
                <v-select
                  :items="$store.state.TestingStatus"
                  label="Testing Status"
                  v-model="updateTestingStatus"
                ></v-select>
              </v-flex>
              <!--<v-flex xs12 sm12 md12 lg12 xlg12>
                <v-text-field label="Tracking" v-model="tracking"></v-text-field>
              </v-flex>-->
              <!--<v-flex xs12 sm6 md6 lg6 xlg6>
                <v-menu
                  v-model="menuShipDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="shipDate"
                      label="Ship Date"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="shipDate" @input="menuShipDate = false"></v-date-picker>
                </v-menu>
              </v-flex>-->
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="secondary"
              @click="updateSelected"
              :disabled="isUpdateDisabled"
            >Update Selected</v-btn>
            <v-btn @click="clearUpdateValues">Clear</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-card>
      <v-data-table
        :headers="serialHeaders"
        :items="searchResults"
        class="elevation-1 spacer"
        item-key="serialNumber"
        select-all
        v-model="selected"
        :loading="$store.state.loading > 0"
        :pagination.sync="pagination"
      >
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

        <template v-slot:items="serialProps">
          <tr>
            <td>
              <v-checkbox v-model="serialProps.selected" primary hide-details></v-checkbox>
            </td>
            <td nowrap>{{serialProps.item.requestId}}</td>
            <td nowrap>{{serialProps.item.itemId}}</td>
            <td nowrap>{{serialProps.item.serialNumber}}</td>
            <td nowrap>{{serialProps.item.ecoStatus}}</td>
            <td nowrap>{{serialProps.item.fulfillmentStatus}}</td>
            <td nowrap>{{serialProps.item.shipDate}}</td>
            <td nowrap><a :href="getTracking(serialProps.item.tracking)" target="_blank">{{serialProps.item.tracking}}</a></td>
            <td nowrap>{{serialProps.item.testingStatus}}</td>
          </tr>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-btn color="success" @click="exportResults" :disabled="areThereResults">Export</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
        v-model="serialDialog"
        width="500"
    >
      <SerialNumberModal
      :request-id="serialEditRequestId"
      :request-line-id="serialEditRequestLineId"
      v-on:save="saveSerial"
      :existing-serial="serialEditExistingSerialItem"
      :request-item-id="serialEditRequestItemId"
      allow-bulk="false"
      />
    </v-dialog>
     <v-snackbar
      v-model="snackbar"
    >
      {{ message }}
      <v-btn
        color="white"
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import http from "../http";
import { baseApiUrl } from "../config";
import { saveAs } from 'file-saver';
import SerialNumberModal from './SerialNumberModal';

export default {
  name: "VendorDashboard",
  data() {
    return {
      serialHeaders: [
        { text: "Request ID", value: "requestId" },
        { text: "Item ID", value: "itemId" },
        { text: "Serial #", value: "serialNumber" },
        { text: "ECO Status", value: "ecoStatus" },
        { text: "Fulfillment Status", value: "fulfillmentStatus" },
        { text: "Ship Date", value: "shipDate" },
        { text: "Tracking", value: "tracking" },
        { text: "Testing Status", value: "testingStatus" }
      ],
      searchResults: undefined,
      menuShipDate: undefined,
      selected: [],
      message: '',
      snackbar: false,

      // Search Fields
      requestStatus: undefined,
      requestId: undefined,
      itemId: undefined,
      ecoStatus: undefined,
      fulfillmentStatus: undefined,
      testingStatus: undefined,

      // updateFields
      shipDate: undefined,
      tracking: undefined,
      selectedItems: [],
      updateEcoStatus: undefined,
      updateTestingStatus: undefined,
      updateFulfillmentStatus: undefined,

      pagination: {
        rowsPerPage: 25,
      },

      // serial modal fields
      serialEditRequestId: undefined,
      serialEditRequestLineId: undefined,
      serialEditExistingSerialItem: undefined,
      serialEditRequestItemId: undefined,
      serialDialog: false,

      selectedVendors: [],
    };
  },
  components: {
      SerialNumberModal,
  },
  computed: {
    areThereResults() {
      if (this.searchResults && this.searchResults.length > 0) return false;
      return true;
    },
    isSearchable: function() {
      const searchable =
        this.requestStatus ||
        this.requestId ||
        this.itemId ||
        this.ecoStatus ||
        this.fulfillmentStatus ||
        this.testingStatus ||
        this.selectedVendors.length > 0 ||
        false;
      console.log("searchable:", !searchable);

      return !searchable;
    },
    isUpdateDisabled: function() {
      return (
        this.selected.length === 0 ||
        (!this.shipDate &&
          !this.tracking &&
          !this.updateEcoStatus &&
          !this.updateTestingStatus &&
          !this.updateFulfillmentStatus)
      );
    }
  },
  methods: {
    showSerialEditor(item) {
      console.log('showSerialEditor:', item);
      this.serialEditRequestId = item.requestId;
      this.serialEditRequestLineId = item.requestLineId;
      this.serialEditExistingSerialItem = item;
      this.serialEditRequestItemId = item.itemId;
      this.serialDialog = true;
    },
    async saveSerial(updatedSerial) {
      console.log('saveSerial - updatedSerial:', updatedSerial);

      this.serialDialog = false;

      console.log('updatedSerial Data:', updatedSerial, updatedSerial.requestLineId);
      await http.put(`${baseApiUrl}/request/serial/${this.serialEditRequestId}/${this.serialEditRequestLineId}`, updatedSerial);

      this.serialEditRequestId = undefined;
      this.serialEditRequestLineId = undefined;
      this.serialEditExistingSerialItem = undefined;
      this.serialEditRequestItemId = undefined;

      await this.search();
    },
    getTracking(trackingNumber) {
      if (!trackingNumber) return '';
      if (!trackingNumber.indexOf('4') === 0) return '';

      return `https://www.fedex.com/apps/fedextrack/?tracknumbers=${trackingNumber}`;
    },
    exportResults() {
      // get headers
      // RequestID, Item ID, Serial Number, Date Added, ECO Status, Fulfillment Status, Testing Status
//      const headers = `"dateAdded","ecoStatus","fulfillmentStatus","itemId","requestId","requestLineId","serialNumber"`;
      const headers = `"RequestID","Item ID","Serial Number","Date Added","ECO Status","Fulfillment Status","Testing Status"`;
      const lines = [headers];

      // build lines
      for(let line of this.searchResults) {
        lines.push(`"${line.requestId}","${line.itemId.replace('"', '""')}","${line.serialNumber.replace('"', '""')}","${line.dateAdded}","${line.ecoStatus || ''}","${line.fulfillmentStatus || ''}","${line.testingStatus || ''}"`);
        // lines.push(`"${line.dateAdded}","${line.ecoStatus}","${line.fulfillmentStatus}","${line.itemId.replace('"', '""')}","${line.requestId}","${line.requestLineId}","${line.serialNumber.replace('"', '""')}"`);
      }

      // download
      const blob = new Blob([lines.join('\n')], {type: "text/plain;charset=utf-8"});
      saveAs(blob, "serial-export.csv");
    },
    clearSearchFilter() {
      this.requestStatus = undefined;
      this.requestId = undefined;
      this.itemId = undefined;
      this.ecoStatus = undefined;
      this.fulfillmentStatus = undefined;
      this.testingStatus = undefined;
    },
    clearUpdateValues() {
      this.shipDate = undefined;
      this.tracking = undefined;
      this.updateEcoStatus = undefined;
      this.updateTestingStatus = undefined;
      this.updateFulfillmentStatus = undefined;
    },
    async search() {
      console.log("search called.");

      if (!this.selectedVendors.length > 0) {
        this.message = 'You must select at least one vendor.';
        this.snackbar = true;
        return;
      }

      const results = await http.get(
        `${baseApiUrl}/search/serial?${this.formatQueryString()}`
      );
      console.log("results.data:", results.data);

      this.searchResults = results.data;
    },

    formatQueryString() {
      const parameters = {
        requestStatus: this.requestStatus,
        requestId: this.requestId,
        itemId: this.itemId,
        ecoStatus: this.ecoStatus,
        fulfillmentStatus: this.fulfillmentStatus,
        testingStatus: this.testingStatus,
        vendors: this.selectedVendors.join(','),
      };

      let queryString = "";
      for (let key of Object.keys(parameters)) {
        if (parameters[key]) {
          queryString += `&${key}=${encodeURIComponent(parameters[key])}`;
        }
      }

      if (queryString.length > 0) {
        queryString = queryString.substring(1);
      }

      return queryString;
    },
    async updateSelected() {
      const updateRequest = {
        serialLines: this.selected.map(row => {
          return {
            requestId: row.requestId,
            requestLineId: row.requestLineId,
            serialNumber: row.serialNumber
          };
        }),
        ecoStatus: this.updateEcoStatus,
        fulfillmentStatus: this.updateFulfillmentStatus,
        testingStatus: this.updateTestingStatus,
        tracking: this.tracking,
        shipDate: this.shipDate
      };

      await http.post(`${baseApiUrl}/serial/bulk`, updateRequest);
      this.clearUpdateValues();
      await this.search();
    }
  },
  async beforeCreate() {},

  beforeUpdate() {
    if (this.selectedVendors.length === 0 && this.$store.state.user.vendorGroups && this.$store.state.user.vendorGroups.length > 0) {
      this.selectedVendors = this.$store.state.user.vendorGroups;
    }
  },

  mounted() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'Vendor Dashboard', disabled: true },
    ]);
  },
};
</script>

<style>
.remove-top-padding {
  padding-top: 0px;
  padding-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
}

.spacer {
  margin-top: 12px;
}
</style>
